export enum TabStatus {
  Error = 'error',
  Loaded = 'loaded',
  Loading = 'loading',
}

export interface Props {
	roomId?: string | null
	updateChatStatus: (status: TabStatus) => void
}